import {
  type CoworkerAndTeamSelectionMode,
  type TeamSelection,
} from "@repo/api";

import { type Action } from "./reducer";

export const showTeamSelection = (
  selectionMode: CoworkerAndTeamSelectionMode
) => selectionMode.selectTeamWithMembers === true;

export const showOnlyTeamSelection = (
  selectionMode: CoworkerAndTeamSelectionMode
) => selectionMode.selectOnlyTeam === true;

export const isMultiCoworkerSelection = (
  selectionMode: CoworkerAndTeamSelectionMode
) => selectionMode.coworkerSelectionMode === "MULTI";

export const isSingleCoworkerSelection = (
  selectionMode: CoworkerAndTeamSelectionMode
) => selectionMode.coworkerSelectionMode === "SINGLE";

export const canToggleMembers = (selectionMode: CoworkerAndTeamSelectionMode) =>
  selectionMode.toggleTeamMembers === true;

export const applyMemberToggle = (
  selected: TeamSelection,
  mode: CoworkerAndTeamSelectionMode,
  emailId: string
): Action => {
  if (selected.assignedToTeam) {
    const member = selected.members.find((m) => m.emailId === emailId);
    if (!member) {
      return { type: "SET_COWORKERS", payload: undefined };
    }
    const { selected: _, ...userInfo } = member;
    return { type: "SET_COWORKERS", payload: [userInfo] };
  }
  if (canToggleMembers(mode)) {
    return { type: "TOGGLE_TEAM_MEMBER", payload: emailId };
  }
  const remaining = selected.members
    .filter((m) => m.selected && m.emailId !== emailId)
    .map(({ selected: _selected, ...u }) => u);
  return {
    type: "SET_COWORKERS",
    payload: remaining.length ? remaining : undefined,
  };
};
